<script lang="ts">
    import type NudgesEntity from "@modules/nudges/entities/NudgesEntity";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    import { nudgesCustomerRewardsState } from "../state/nudgesCustomerRewardsState";

    export let nudges: NudgesEntity;

    const {
        nudgesService,
        NudgesPopUpWidgetVisibilityManager,
        locationController,
    } = nudgesCustomerRewardsState();

    const handleAddView = () => {
        nudgesService.addAction({
            nudgeId: nudges.nudge.id,
        });
        nudgesService.addViewed({
            nudgeId: nudges.nudge.id,
        });
        NudgesPopUpWidgetVisibilityManager.nudgesPopUpWidgetHide();

        locationController.goTo(nudges.template.ctaw.link || "/account/login");
    };
</script>

<BaseButton
    class="gw-nudges-modal__active-button"
    on:click={() => handleAddView()}>{nudges.template.ctaw.text}</BaseButton
>
